import { z } from 'zod';

import { FeedbackSourceSchema } from './feedback.js';

// NOTIFY payload schemas for the Feedback Pool.
//
// `feedback_ingested` is emitted by the feedback_pool_notify_ingested
// trigger (migration 0016) on every insert into feedback_pool. The AI
// enrichment worker in apps/bot listens on this channel; the payload is
// intentionally minimal, so the worker fetches the full row by id.

export const FeedbackIngestedPayloadSchema = z.object({
  feedbackId: z.string().uuid(),
  studioId: z.string().uuid(),
  gameId: z.string().uuid(),
  source: FeedbackSourceSchema,
  externalId: z.string().nullable(),
});
export type FeedbackIngestedPayload = z.infer<typeof FeedbackIngestedPayloadSchema>;
